@if (isLoader) {
  <div class="h-full">
    <app-sidebar-header (close)="cancel()" [title]="('integration' | translate) + ' Ringostat'"></app-sidebar-header>
    <div class="flex h-64 items-center justify-center">
      <app-loader size="big"></app-loader>
    </div>
  </div>
} @else {
  <div class="h-full overflow-auto bg-gray-50">
    <app-sidebar-header (close)="cancel()" [title]="('integration' | translate) + ' Ringostat'"></app-sidebar-header>

    <div class="m-3 flex flex-col gap-4 rounded-lg bg-white p-4">
      <div class="flex flex-wrap gap-4">
        <img class="h-12 w-12 rounded-full" src="/assets/svgs/integrations/ringostat-logo.svg" alt="Ringostat logo" />
        <div>
          <h5 class="m-0 text-base font-semibold text-gray-900">
            {{ 'log_in_with_your_Ringostat_account' | translate }}
          </h5>
          <p class="m-0 mt-1 text-sm text-gray-600">{{ 'channel' | translate }}: {{ channel.name }}</p>
          <p class="m-0 mt-1 text-sm text-gray-600">
            {{ 'status' | translate }}:
            <span
              class="rounded px-2 py-0.5 text-xs font-medium text-white"
              [ngStyle]="{ 'background-color': $safeNavigationMigration(statuses[channel.status]?.color) }"
            >
              {{
                statuses[channel.status]?.translate && statuses[channel.status]?.title
                  ? ($safeNavigationMigration(statuses[channel.status]?.title) | translate)
                  : statuses[channel.status]?.title
              }}
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="m-3 flex flex-col gap-3 rounded-lg bg-white p-4">
      <h5 class="m-0 text-base font-semibold text-gray-900">{{ 'information' | translate }}</h5>
      <hr class="m-0 border-gray-100" />

      <div>
        <span class="mb-1 block text-sm text-gray-700">{{ 'api_key' | translate }}</span>
        <app-text-field
          [error]="form.controls.api_key.touched && form.controls.api_key.invalid"
          (focusout)="form.controls.api_key.markAsTouched()"
          [formControl]="form.controls.api_key"
        ></app-text-field>
        @if (form.controls.api_key.touched && form.controls.api_key.invalid) {
          <span class="mt-1 block text-xs text-red-600">
            @if (form.controls.api_key.errors?.['required']) {
              {{ 'field_cannot_be_empty' | translate }}
            }
          </span>
        }
      </div>

      <div>
        <span class="mb-1 block text-sm text-gray-700">{{ 'ringostat_project_id' | translate }}</span>
        <app-text-field
          [error]="form.controls.project_id.touched && form.controls.project_id.invalid"
          (focusout)="form.controls.project_id.markAsTouched()"
          [formControl]="form.controls.project_id"
        ></app-text-field>
        @if (form.controls.project_id.touched && form.controls.project_id.invalid) {
          <span class="mt-1 block text-xs text-red-600">
            @if (form.controls.project_id.errors?.['required']) {
              {{ 'field_cannot_be_empty' | translate }}
            }
          </span>
        }
      </div>

      <div>
        <span class="mb-1 block text-sm text-gray-700">{{ 'ringostat_webhook_hint' | translate }}</span>
        <app-text-field [disabled]="true" [input]="webhookUrl + '/' + channel.id"></app-text-field>
      </div>

      <div class="flex gap-2">
        <div class="flex-1"></div>
        <app-button [customClass]="'bg-danger'" btnType="cancel" (onChangeClick)="cancel()">{{
          'cancel' | translate
        }}</app-button>
        <app-button [disabled]="form.invalid || !form.dirty" (onChangeClick)="save()">{{
          'save' | translate
        }}</app-button>
      </div>
    </div>
  </div>
}
